import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import AdminNavbar from "./AdminNavbar";

const API_URL = process.env.REACT_APP_API_URL;

export default function ManageProjects() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      const res = await fetch(`${API_URL}/api/projects`);
      const data = await res.json();
      setItems(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const handleDelete = async (name) => {
    const ok = await Swal.fire({
      icon: "warning",
      title: "Delete this project?",
      text: "This cannot be undone.",
      showCancelButton: true,
      confirmButtonText: "Delete",
      confirmButtonColor: "#DC2626",
    });
    if (!ok.isConfirmed) return;

    try {
      const res = await fetch(
        `${API_URL}/api/projects/${encodeURIComponent(name)}`,
        { method: "DELETE" }
      );
      if (!res.ok) throw new Error();
      setItems(items.filter((i) => i.name !== name));
      Swal.fire({ icon: "success", title: "Deleted.", confirmButtonColor: "#DC2626" });
    } catch {
      Swal.fire({ icon: "error", title: "Delete failed", confirmButtonColor: "#DC2626" });
    }
  };

  return (
    <div className="admin-shell">
      <AdminNavbar />

      <div className="admin-page">
        <div className="admin-head">
          <div>
            <p className="eyebrow">Portfolio</p>
            <h1>Manage <em>projects</em>.</h1>
          </div>
          <Link to="/CreateProject" className="btn-new">New Project</Link>
        </div>

        {loading ? (
          <div className="loader-wrap"><div className="loader" /></div>
        ) : items.length === 0 ? (
          <p className="empty-state">No projects yet — document your first one.</p>
        ) : (
          <table className="admin-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Thumb</th>
                <th>Date</th>
                <th style={{ textAlign: "right" }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {items.map((p) => (
                <tr key={p._id}>
                  <td style={{ fontWeight: 500 }}>{p.name}</td>
                  <td>{p.thumbnail && <img src={p.thumbnail} alt="" />}</td>
                  <td>{new Date(p.date).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })}</td>
                  <td style={{ textAlign: "right" }}>
                    <Link
                      to={`/projects/${encodeURIComponent(p.name)}`}
                      className="btn-outline"
                      style={{ padding: "0.45rem 0.95rem", fontSize: "0.72rem", marginRight: "0.5rem" }}
                    >
                      View
                    </Link>
                    <Link
                      to={`/EditProject/${encodeURIComponent(p.name)}`}
                      className="btn-outline"
                      style={{ padding: "0.45rem 0.95rem", fontSize: "0.72rem", marginRight: "0.5rem" }}
                    >
                      Edit
                    </Link>
                    <button className="btn-delete" onClick={() => handleDelete(p.name)}>
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
